import { render, staticRenderFns } from "./CollapseNotification.vue?vue&type=template&id=bd3c039e&scoped=true&"
import script from "./CollapseNotification.vue?vue&type=script&lang=js&"
export * from "./CollapseNotification.vue?vue&type=script&lang=js&"
import style0 from "./CollapseNotification.vue?vue&type=style&index=0&id=bd3c039e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3c039e",
  null
  
)

export default component.exports